module.exports = __webpack_public_path__ + "static/media/online-compress.b4eae2ab.jpg";